import { Entity } from "@jobilla/entity";

export class UserPermissionInfo extends Entity {
  companies!: Record<number, string[]>;
  objects!: string[];
  units!: Record<string, string[]>;
}
